// extracted by mini-css-extract-plugin
export var link = "_td-0";